import styled from "styled-components/macro";
import { ToggleSelect, LabelDollarFormatted, LabelPercentFormatted, LabelDecimal } from "@loanbossinc/component-library";
import { RadioGroup } from "@material-ui/core";

import { StyledSelectButton } from "./formulaFields/styles";

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1em"};
  }
`;

export const Container = styled.div`
  align-items: center;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledToggleSelect = styled(ToggleSelect)`
  margin-top: 0.5em;
  & button {
    width: 100px;
  }

  & button[aria-pressed="true"] {
    pointer-events: none;
  }
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0.5em 0 0 0;
  border-bottom: 1px solid #dadce0;
  line-height: 1;
`;

export const StyledDoneButton = styled(StyledSelectButton)`
  display: flex;
  justify-content: flex-end;
  &:disabled,
  &[disabled] {
    background-color: #c4c4c4 !important;
  }
`;

export const StyledDollarLabel = styled(LabelDollarFormatted)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const StyledPercentLabel = styled(LabelPercentFormatted)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
  }
`;
export const StyledDecimalLabel = styled(LabelDecimal)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 16px !important;
    line-height: 21px;
  }
`;

export const PropertyFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFieldType = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #5f6368;
`;

export const SelectedPropertyLeftWrapper = styled.div`
  display: flex;
`;

export const PropertyName = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.multi && "#0F9AD6"};
`;

export const FieldName = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row !important;
`;

export const OperationTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5em 1em 0.7em 1em;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #dadce0;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
`;

export const ComparisonTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em 1em 0.7em 1em;
  border-bottom: 1px solid #dadce0;
  width: 100%;
  box-sizing: border-box;
`;

export const StyledToggleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1;
  margin-right: ${props => props.mr};
`;
